import IconNamesType from 'presentation/icons/IconNamesType';

type VariantType = 'warning' | 'error' | 'success' | 'info' | 'primary' | 'secondary' | 'default';

type SizeType = 'big' | 'medium' | 'small' | 'smaller' | 'custom';

const iconName: Record<VariantType, IconNamesType> = {
	default: 'perm-device-information-filled',
	success: 'check-circle-outline-filled',
	info: 'info-filled',
	warning: 'warning-outlined',
	error: 'error-outline',
	primary: 'help-outline-filled',
	secondary: 'perm-device-information-filled',
};

const iconSize: Record<SizeType, number> = {
	medium: 32,
	small: 24,
	smaller: 20,
	big: 48,
	custom: 24,
};

export type {VariantType, SizeType};
export {iconName, iconSize};
